import { z } from 'zod';
import { LogisticsCalculationContentSchema } from './content.js';
import {
  LogisticsCalculationOutputSchema,
  LogisticsCalculationMoneySchema,
} from './calculation.js';
import {
  LOGISTICS_CALCULATION_PUBLIC_CODE_REGEX,
  LogisticsCalculationStatus,
  LogisticsCalculationStatusSchema,
} from './status.js';

export const LogisticsCalculationSnapshotSchema = z
  .object({
    content: LogisticsCalculationContentSchema,
    calculation: LogisticsCalculationOutputSchema,
  })
  .strict();

export const LogisticsCalculationListItemSchema = z
  .object({
    id: z.string().uuid(),
    publicCode: z.string().regex(LOGISTICS_CALCULATION_PUBLIC_CODE_REGEX),
    status: LogisticsCalculationStatusSchema,
    clientCompany: z.string(),
    ownerName: z.string(),
    cargoCount: z.number().int().nonnegative(),
    cargoArticles: z.array(z.string()).optional(),
    totalUsd: LogisticsCalculationMoneySchema.nullable(),
    totalRub: LogisticsCalculationMoneySchema.nullable(),
    htmlViewCount: z.number().int().nonnegative(),
    updatedAt: z.string().datetime(),
  })
  .strict();
export type LogisticsCalculationListItem = z.infer<typeof LogisticsCalculationListItemSchema>;

export const LogisticsCalculationDetailSchema = z
  .object({
    id: z.string().uuid(),
    publicCode: z.string().regex(LOGISTICS_CALCULATION_PUBLIC_CODE_REGEX),
    ownerId: z.string().uuid(),
    status: LogisticsCalculationStatusSchema,
    content: LogisticsCalculationContentSchema,
    calculation: LogisticsCalculationOutputSchema,
    snapshot: LogisticsCalculationSnapshotSchema.nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    publishedAt: z.string().datetime().nullable(),
    publishedById: z.string().uuid().nullable(),
    revokedAt: z.string().datetime().nullable(),
    revokedById: z.string().uuid().nullable(),
  })
  .strict()
  .superRefine((value, ctx) => {
    if (value.status === LogisticsCalculationStatus.PUBLISHED && value.snapshot === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['snapshot'],
        message: 'snapshot must be non-null when status is PUBLISHED',
      });
    }
    if (value.status === LogisticsCalculationStatus.DRAFT && value.snapshot !== null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['snapshot'],
        message: 'snapshot must be null when status is DRAFT',
      });
    }
  });
export type LogisticsCalculationDetail = z.infer<typeof LogisticsCalculationDetailSchema>;
